// extracted by mini-css-extract-plugin
export default {"products-container":"products-list_products-container__Xxc3Z","title-container":"products-list_title-container__Pb-QL","products-title":"products-list_products-title__GUDbh"};